import styled from "styled-components"
import { useAuthorisedValuesCategory } from "../../controllers/AuthorisedValuesCategoryController";
import { Row, Col, Button, Input } from '../../../ui/ot'
import { useState } from "react";
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";

const AuthorisedValuesCategoryNew = ({
    keyPrefix = 'library.backstage.authorized_values_management'

}) => {
    const thisJS = "AuthorisedValuesCategoryNew"
    const [category, setCategory] = useState("")
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate()
    const {
        postAuthorisedValuesCategoryData,
    } = useAuthorisedValuesCategory({
        onBefore: ({ axiosMode, values }) => {
            console.log(thisJS, "postAuthorisedValuesCategoryData", axiosMode, "onBefore", values)
        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "postAuthorisedValuesCategoryData", axiosMode, "onFinish", status, values)
            navigate(`/library/backstage/authorized_values_management/${category}`)
        }
    })

    return (
        <Row gutter={[8,8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Title>{t('new_category')}</Title>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Row align ={'middle'} gutter={[4,4]}>
                    <Col>
                        <FieldTitleRed>{t('category')}:</FieldTitleRed>
                    </Col>
                    <Col>
                        <Input placeholder="請輸入..." value={category} onChange={(e) => { setCategory(e.target.value) }} />
                    </Col>
                </Row>
            </Col>

            <Col span={24}>

                <Row>
                    <Col>
                        <ButtonGroup classnName='mt-4'>
                            <Button onClick={() => { postAuthorisedValuesCategoryData([{ category }]) }}>新增項目</Button>
                            <Button variant="outline" onClick={() => navigate(`/library/backstage/authorized_values_management`)} >取消</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`
const FieldTitleRed = styled.div`
text-align: left;
font-size: 1.1em;
font-weight: 500;
color: red;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default AuthorisedValuesCategoryNew